import { render, staticRenderFns } from "./apsresult.vue?vue&type=template&id=872b3262&scoped=true&"
import script from "./apsresult.vue?vue&type=script&lang=js&"
export * from "./apsresult.vue?vue&type=script&lang=js&"
import style0 from "./apsresult.vue?vue&type=style&index=0&id=872b3262&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872b3262",
  null
  
)

export default component.exports